// Avatar.js
import React from "react";
import { PiUserCircle } from "react-icons/pi";
import { useSelector } from "react-redux";
import GetFile from "../GetFile";

const Avatar = ({ userId, name,  imageUrl, width, height, sizeType = "px" }) => {
  const onlineUser = useSelector((state) => state?.auth?.onlineUser);
  let shape = "rounded-full";

  if (width > 90 || sizeType !== "px") shape = "square";
  let avatarName = "";
  if (name) {
    const splitName = name?.split(" ");

    if (splitName.length > 1) {
      avatarName = splitName[0][0] + splitName[1][0];
    } else {
      avatarName = splitName[0][0] + splitName[0][1];
    }
  }

  const isOnline = onlineUser.includes(userId);
  return (
    <div
      className={`text-slate-800  ${shape}  font-bold relative `}
      style={{
        width: width + sizeType,
        height: height + sizeType,
      }}
    >
      <div
        style={{
          width: width + sizeType,
          height: height + sizeType,
        }}
        className={` overflow-hidden   ${shape}  flex justify-center items-baseline text-lg`}
      >
        <div className=" bg-orange-200  ">
          {imageUrl ? (
            <GetFile fileName={`avatar250-${imageUrl}`} />
          ) : name ? (
            avatarName.toLocaleUpperCase()
          ) : (
            <PiUserCircle size={width} />
          )}
        </div>
      </div>
      {isOnline && (
        <div className="bg-green-600 p-1 absolute bottom-2 -right-1 z-10 rounded-full"></div>
      )}
    </div>
  );
};

export default Avatar;
